import { SettingsItem }                             from '@/views/settings/types/types';
import { path as priceOptimizerAlgorithmsBasePath } from '@/views/price-optimizer-algorithms/price-optimizer-algorithms.route';

export interface State {
  settingsList: SettingsItem[];
}

const state: State = {
  settingsList: [
    {
      name: 'generalSettings',
      links: [
        {
          name: 'strategies',
          path: '/settings/strategies',
        },
        {
          name: 'seasons',
          path: '/settings/seasons',
        },
        {
          name: 'users',
          path: '/settings/users',
        },
      ],
    }, {
      name: 'priceOptimizerName',
      links: [
        {
          name: 'algorithms',
          path: priceOptimizerAlgorithmsBasePath,
        },
        {
          name: 'compsetCreator',
          path: '/settings/compset-creator',
        },
        {
          name: 'changelogSettings',
          path: '/settings/changelog-settings',
        },
      ],
    }, {
      name: 'dashboardSettings',
      links: [
        {
          name: 'heatMapConfiguration',
          path: '/settings/heat-map-configuration',
        },
        {
          name: 'calendarConfiguration',
          path: '/settings/calendar-configuration',
        },
      ],
    },
  ],
};

export default state;
